var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "gfu-layout-wrapper gfu-layout-wrapper--extranarrow _pb-3 _pt-2 _pt-3--m",
      attrs: { "data-qa": "project-banner" },
    },
    [
      _c(
        "span",
        {
          staticClass: "gfu-project-banner__title",
          attrs: { "data-qa": "project-banner-title" },
        },
        [
          _c(
            "a",
            {
              staticClass: "gfu-link gfu-link--nofx",
              attrs: {
                href: _vm.projectHomeUrl,
                "data-qa": "project-banner-title-url",
              },
            },
            [_vm._v(_vm._s(_vm.projectName))]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gfu-project-banner__title-annotation" },
        [
          _c("creators-line", {
            attrs: {
              creator: _vm.mappedCreator,
              "co-creators": _vm.mappedCoCreators,
              "show-as-links": "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gfu-project-banner__description",
          attrs: { "data-qa": "project-banner-description" },
        },
        [_vm._v("\n        " + _vm._s(_vm.projectShortDescription) + "\n    ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }